import Component, { mixins } from 'vue-class-component'
import MixinStock from '@mixins/stock'
import stockItem from '../item/index.vue'

@Component({
  components: {
    'vgb-stock-item': stockItem,
  },
})
export default class Molecules extends mixins(MixinStock) {
}
